import { Box, type SxProps, type Theme } from "@mui/material";

interface AppMarkProps {
  size?: number;
  fontSize?: number;
  borderRadius?: number;
  sx?: SxProps<Theme>;
}

/**
 * Compact "1T" mark used in the shell and account views (theme primary).
 */
export function AppMark({ size = 32, fontSize = 14, borderRadius = 2, sx }: AppMarkProps) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        bgcolor: "primary.main",
        borderRadius,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "primary.contrastText",
        fontWeight: "bold",
        fontSize,
        ...sx,
      }}
    >
      1T
    </Box>
  );
}
